/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a92ee1730de0353b6ca51e6643815d96e1387209";
